module.exports = __WEBPACK_EXTERNAL_MODULE_27__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 27
// module chunks = 0